import { PLATFORM_OPTIONS } from '../pages/posts/constants';
import { SHOW_INSTAGRAM_AS_PUBLISH_TARGET } from '../config/featureFlags';

/** Normalize platform account / form slugs for publish targeting. */
export function normalizePublishPlatformSlug(platform) {
  const p = String(platform || '')
    .trim()
    .toLowerCase();
  if (!p) return '';
  if (p === 'facebook_page' || p === 'fb' || p === 'meta') return 'facebook';
  if (p === 'ig') return 'instagram';
  if (p === 'li') return 'linkedin';
  if (p === 'yt') return 'youtube';
  if (p === 'twitter') return 'x';
  return p;
}

/**
 * Platform options limited to active connected accounts for a client.
 * Falls back to full PLATFORM_OPTIONS when client has no accounts loaded yet
 * only when ``fallbackAll`` is true (default false → empty until connected).
 */
export function connectedPlatformOptions(
  platformAccounts,
  clientId,
  { fallbackAll = false } = {},
) {
  const allowed = new Set(
    (PLATFORM_OPTIONS || []).map((o) => normalizePublishPlatformSlug(o.value)),
  );
  if (!SHOW_INSTAGRAM_AS_PUBLISH_TARGET) {
    allowed.delete('instagram');
  }

  const cid = clientId != null && clientId !== '' ? String(clientId) : null;
  const connected = new Set();
  for (const account of Array.isArray(platformAccounts) ? platformAccounts : []) {
    if (account?.is_active === false) continue;
    if (cid && account.client_id != null && String(account.client_id) !== cid) {
      continue;
    }
    const slug = normalizePublishPlatformSlug(account.platform);
    if (slug && allowed.has(slug)) connected.add(slug);
  }

  const options = (PLATFORM_OPTIONS || []).filter((o) =>
    connected.has(normalizePublishPlatformSlug(o.value)),
  );
  if (options.length) return options;
  return fallbackAll ? PLATFORM_OPTIONS : [];
}

export function defaultConnectedPlatforms(platformAccounts, clientId) {
  return connectedPlatformOptions(platformAccounts, clientId).map((o) => o.value);
}
